import React from 'react'
import Modal from '../../modals/wrapper'
import GoalEditForm from '../edit-form'
import useClientLocation from '../../../hooks/use-client-location'
import useCurrentUser from '../../../hooks/use-current-user'
import { get } from 'lodash'

const GoalEditModal = () => {
    const { currentUser } = useCurrentUser()
    const { params, goBack } = useClientLocation()
    const userId = params.userId || get(currentUser, 'id')
    const goalId = params.goalId !== 'new' ? params.goalId : undefined
    return (
        <Modal
            onHide={goBack}
            closeButton
        >
            <GoalEditForm
                userId={userId}
                goalId={goalId}
                onComplete={goBack}
            />
        </Modal>
    )
}

export default GoalEditModal